export const getPaymentRefererUrl = (state) => state.payment.stripe.refererUrl;
